"use strict";
(function () {
  class UpdatesReactions extends HttpRequest {
    constructor() {
      super();
      this.#init();
    }

    #init() {
      const actionGroups = document.querySelectorAll(".br-fb-post__actions[data-post-id]");
      actionGroups.forEach((group) => {
        const postId = group.getAttribute("data-post-id");
        this.#bindReactButtons(group, postId);
        this.#bindShareButton(group, postId);
      });
    }

    #bindReactButtons(group, postId) {
      const buttons = group.querySelectorAll('button[data-type="react"]');
      const countEl = group.querySelector(".br-fb-post__count");

      buttons.forEach((button) => {
        button.addEventListener("click", async () => {
          const link = button.getAttribute("data-link");
          if (link) {
            location.href = link;
            return;
          }

          const action = button.getAttribute("data-action");
          ShowLoading(button);

          try {
            const formData = new FormData();
            formData.append("module", "Posts");
            formData.append("action", "SubmitReactPost");
            formData.append("post", postId);
            formData.append("type", action);

            const result = await this.FormRequest(formData, "");

            if (countEl && !isNaN(result?.likes)) {
              countEl.textContent = result.likes > 99 ? "99+" : result.likes;
            }

            buttons.forEach((btn) => {
              if (btn !== button) {
                btn.classList.remove("br-fb-post__react-btn--active");
              }
            });

            if (["like", "dislike"].includes(result?.action)) {
              button.classList.add("br-fb-post__react-btn--active");
            } else {
              button.classList.remove("br-fb-post__react-btn--active");
            }

            if (result?.message) Toast(result);
          } catch (error) {
            Toast(error);
          } finally {
            HideLoading(button);
          }
        });
      });
    }

    #bindShareButton(group, postId) {
      const shareBtn = group.querySelector('button[data-type="share"]');
      if (!shareBtn) return;

      shareBtn.addEventListener("click", async () => {
        if (!navigator.share) {
          Toast({ status: "success", message: "שיתוף לא זמין בדפדפן זה" });
          return;
        }

        try {
          await navigator.share({
            title: document.title,
            text: "תראו את העדכון הזה!",
            url: window.location.href + "?pid=" + postId,
          });
          Toast({ status: "success", message: "הפוסט שותף בהצלחה!" });
        } catch (_) {
          // user cancelled — no action needed
        }
      });
    }
  }

  new UpdatesReactions();
})();
